module.exports = __webpack_public_path__ + "img/knzb-events.24fdf68b.jpg";